
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { useToast } from '../components/ui/use-toast';

const CommunityPage = () => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const handleAmbassadorApplication = () => {
    window.location.href = "mailto:ambassadors@powderproject.org?subject=Ambassador Application&body=I'm interested in becoming a Powder Project Ambassador.%0D%0A%0D%0APlease tell us about yourself and your interest in winter sports conservation.";
  };

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      toast({
        title: "Invalid Email",
        description: "Please enter a valid email address.",
        variant: "destructive",
      });
      return;
    }

    toast({
      title: "Subscribed!",
      description: "Thank you for subscribing to our newsletter.",
    });
    setEmail('');
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Ambassador Call to Action */}
      <section className="relative">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black" />
          <img 
            src="https://images.unsplash.com/photo-1486496146582-9ffcd0b2b2b7?auto=format&fit=crop&w=2000"
            alt="Skier in powder"
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="relative max-w-6xl mx-auto px-4 py-32">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <h1 className="text-5xl font-bold text-white mb-6">
              Become a Powder Project Ambassador
            </h1>
            <p className="text-xl text-blue-200 mb-8">
              We're looking for passionate individuals who want to lead the charge in protecting winter sports. Whether you're an athlete, educator, or enthusiast, your voice matters.
            </p>
            <div className="grid md:grid-cols-3 gap-6 mb-8">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <h3 className="text-xl font-bold text-white mb-2">Advocate</h3>
                <p className="text-blue-200">Share our mission and inspire others to take action</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <h3 className="text-xl font-bold text-white mb-2">Connect</h3>
                <p className="text-blue-200">Build relationships within the winter sports community</p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <h3 className="text-xl font-bold text-white mb-2">Impact</h3>
                <p className="text-blue-200">Lead initiatives that make a real difference</p>
              </div>
            </div>
            <Button
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8"
              onClick={handleAmbassadorApplication}
            >
              Apply to Be an Ambassador
            </Button>
          </motion.div>
        </div>
      </section>

      {/* Future Instagram Feed Section */}
      <section className="max-w-6xl mx-auto px-4 py-24">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-4xl font-bold text-white text-center mb-16"
        >
          Join the Community
        </motion.h2>

        <div className="text-center text-blue-200 mb-12">
          <p>Share your journey with #PowderPromise</p>
          <p className="mt-2">Be one of the first to share your story!</p>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <Button
            size="lg"
            className="bg-blue-600 hover:bg-blue-700 text-white"
            onClick={() => window.open('https://www.instagram.com/explore/tags/powderpromise/', '_blank')}
          >
            Share Your Story
          </Button>
        </motion.div>
      </section>

      {/* Newsletter Signup */}
      <section className="max-w-4xl mx-auto px-4 pb-24">
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-8 text-center">
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-2xl font-bold text-white mb-4"
          >
            Stay Updated
          </motion.h3>
          <p className="text-blue-200 mb-6">
            Get the latest news and updates from The Powder Project delivered to your inbox.
          </p>
          <form onSubmit={handleSubscribe} className="flex gap-4 max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 px-4 py-2 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50"
            />
            <Button 
              type="submit"
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              Subscribe
            </Button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default CommunityPage;
